export default __webpack_public_path__ + "static/media/NFD_Minting_Guide1024_6.b6699ba4.png";